import { render, staticRenderFns } from "./ForgetThePassword.vue?vue&type=template&id=17dae287&scoped=true&"
import script from "./ForgetThePassword.vue?vue&type=script&lang=js&"
export * from "./ForgetThePassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgetThePassword.vue?vue&type=style&index=0&id=17dae287&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dae287",
  null
  
)

export default component.exports